import {
  GET_ADMIN_USERS_LIST_FAILURE,
  GET_ADMIN_USERS_LIST_REQUEST,
  GET_ADMIN_USERS_LIST_SUCCESS,
  SET_ADMIN_USERS_LIST_PAGE,
} from './UsersList.constant';
import {
  AdminUsersListActionTypes,
  IAdminUsersListData,
} from './UsersList.type';

const initialState: IAdminUsersListData = {
  data: {
    items: [],
    meta: {
      limit: 25,
      page: 1,
      pages: 1,
      skip: 0,
      total: 0,
    },
  },
  isLoading: false,
};

export default function adminUserListReducer(
  state = initialState,
  action: AdminUsersListActionTypes,
): IAdminUsersListData {
  switch (action.type) {
    case GET_ADMIN_USERS_LIST_REQUEST:
      return { ...state, isLoading: true };
    case GET_ADMIN_USERS_LIST_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case GET_ADMIN_USERS_LIST_FAILURE:
      return { ...state, isLoading: false };

    case SET_ADMIN_USERS_LIST_PAGE:
      return {
        ...state,
        data: {
          ...state.data,
          meta: {
            ...state.data.meta,
            page: action.payload,
          },
        },
      };

    default:
      return { ...state };
  }
}
